<div class="auth__container">
  <a
    class="auth__header"
    routerLink="/"
  >
    <img
      class="auth__logo"
      alt="workbase"
      src="/assets/images/logo/workbase.svg"
    />
  </a>
  <wb-box class="auth__content">
    <router-outlet></router-outlet>
  </wb-box>
</div>

<div class="auth__footer">
  <wb-link href="https://www.workbase.com/about" target="_blank">
    Workbase © {{ year }}
  </wb-link>
  <wb-link href="https://www.workbase.com/legal/imprint" target="_blank">
    {{ 'footer.imprint' | translate }}
  </wb-link>
  <wb-link href="https://www.workbase.com/legal/privacy" target="_blank">
    {{ 'footer.privacy' | translate }}
  </wb-link>
  <wb-link href="https:///www.workbase.com/legal/terms-of-services" target="_blank">
    {{ 'footer.termsOfServices' | translate }}
  </wb-link>
</div>
